import { TABS } from '@/features/user/settings/sections/tabs'

export const PLAN_AND_BILLING_PATH = `/accounts?tab=${TABS.PLAN_AND_BILLING}`
export const PAYMENT_METHOD_PATH = '/accounts/billing/payment-method'
export const BILLING_INFORMATION_PATH = '/accounts/billing/information'
